import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTemplateList(data) {
  return request({
    url: URL.sys.templateList,
    method: 'post',
    data
  })
}

export function queryByFileTypeOrTemplateUuids(data) {
  return request({
    url: URL.sys.queryByFileTypeOrTemplateUuids,
    method: 'post',
    data
  })
}

export function getInitTemplateList(params) {
  return request({
    url: URL.sys.initTemplate,
    method: 'get',
    params
  })
}

export function queryInitTempaltes() {
  return request({
    url: URL.sys.queryInitTempaltes,
    method: 'get'
  })
}

export function saveTemplate(data) {
  return request({
    url: URL.sys.template,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 复制打印模板
export function copyTemplate(branchIds, uuid) {
  return request({
    url: URL.sys.copyTemplate + '?uuid=' + encodeURIComponent(uuid),
    method: 'post',
    data: branchIds
  })
}

export function delTemplate(uuid) {
  return request({
    url: URL.sys.template + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 批量删除打印模板
export function batchDeleteTemplate(keys) {
  return request({
    url: URL.sys.batchDeleteTemplate,
    method: 'post',
    data: keys
  })
}

export function queryTemplateByNameAndType(templateType, templateName, tenantId, officeId) {
  return request({
    url: URL.sys.queryTemplateByNameAndType,
    method: 'get',
    params: { templateType, templateName, tenantId, officeId }
  })
}

/* 模板规则名称转换 */
export function getTemplateName(data) {
  return request({
    url: URL.sys.getTemplateName,
    method: 'post',
    data
  })
}

export function saveTemplateAccess(data) {
  return request({
    url: URL.sys.saveTemplateAccess,
    method: 'post',
    data
  })
}

export function queryInitTemplateBySchemaType(schemaType) {
  return request({
    url: URL.sys.queryInitTemplateBySchemaType,
    method: 'get',
    params: { schemaType }
  })
}

export function save(data) {
  return request({
    url: URL.sys.initTemplate,
    method: 'post',
    data
  })
}

export function remove(uuid) {
  return request({
    url: URL.sys.initTemplate,
    method: 'delete',
    params: { uuid: uuid }
  })
}

export function queryTemplatesByTypeMuti(data) {
  return request({
    url: URL.sys.queryTemplatesByTypeMuti,
    method: 'post',
    data
  })
}

// 更新提单状态
export function updateDocCfmState(params) {
  return request({
    url: URL.act.releaseDocRule.updateDocCfmState,
    method: 'put',
    params
  })
}
